/* eslint-disable camelcase */
import _ from 'lodash';
import { useEffect, useState } from 'react';

import cms_api from '../../cms_api';

export const getBadgeData = _.memoize(async code => {
  const [response, response_en] = await Promise.all([
    cms_api.get_single_contents({
      filter: {
        type: 'Cms::Content::Attribute',
        language_iso_code: code,
        route: '/roofing/contractors',
        name: 'FAC Badges',
      },
      fields: {
        '*': 'contents',
      },
    }),
    cms_api.get_single_contents({
      filter: {
        type: 'Cms::Content::Attribute',
        language_iso_code: 'en-US',
        route: '/roofing/contractors',
        name: 'FAC Badges',
      },
      fields: {
        '*': 'contents',
      },
    }),
  ]);

  return response?.items.map(item => ({
    ...item,
    analyticsName: response_en?.items?.filter(item2 => item2.value === item.value)?.[0]?.label || item.label,
  }));
});

export const useBadgeData = code => {
  const [badgeData, setBadgeData] = useState([]);
  useEffect(() => {
    getBadgeData(code).then(setBadgeData);
  }, [code]);
  return badgeData;
};

export async function getDataForBadges(activeBadges, localeCode = 'en-US', whiteList = null) {
  if (!activeBadges || activeBadges.length === 0) {
    return [];
  }

  const badgeData = await getBadgeData(localeCode);
  return badgeData
    .map(badge => {
      const validCodes = Array.wrap(badge.value || []);
      const hasBadge = activeBadges.filter(value => validCodes.includes(value)).length > 0;
      const showBadge = !whiteList || whiteList.filter(value => validCodes.includes(value)).length > 0;
      return hasBadge && showBadge ? badge : null;
    })
    .filter(Boolean);
}
